module.exports = __webpack_public_path__ + "img/4.d1c5012d.webp";